import Tooltip from "@material-ui/core/Tooltip";
// import Button from "@material-ui/core/Button";
// import DeleteIcon from "@material-ui/icons/Delete";
import React, { Component } from "react";
import PtsConfirmDialogue from "../ptsAlert/PtsConfirmDialogue";

export class DeleteButton extends Component {
  confirmDialogueRef = React.createRef();
  constructor(props) {
    let domainObject = props.domainObject ? props.domainObject : "";
    super(props);
    this.state = {
      domainObject: domainObject,
      title: props.title ? props.title : "Delete Confirmation",
      text: props.text ? props.text : domainObject,
      onClick: props.onClick,
      caption: props.caption,
      pageId: this.props.pageId,
      hideToolTip: props.hideToolTip,
      btnName: props.btnName,
    };
  }

  deleteConfirmed() {
    if (this.confirmDialogueRef && this.confirmDialogueRef.current) {
      this.confirmDialogueRef.current.setState({ open: false });
    }
    if (this.state.onClick) {
      this.state.onClick();
    }
  }

  onClick() {
    if (
      this.confirmDialogueRef &&
      this.confirmDialogueRef.current &&
      this.confirmDialogueRef.current.state.open === false
    ) {
      this.confirmDialogueRef.current.handleClickOpen();
    } else {
      this.confirmDialogueRef.current.handleClose();
    }
  }
  render() {
    this.confirmDialogueRef = React.createRef();
    return (
      <span
        style={{
          cursor: "pointer",
          fontSize: "x-larger",
          alignItems: "center",
        }}
      >
        <PtsConfirmDialogue
          ref={this.confirmDialogueRef}
          title={this.state.title}
          btnName={this.state.btnName}
          text={this.props.text ? this.props.text : this.props.domainObject}
          open={false}
          pageId={this.props.pageId}
          confirmCallback={this.deleteConfirmed.bind(this)}
        />
        {/* <Tooltip title="Delete">
          <DeleteIcon
            style={{
              borderRadius: "25%",
              color: "#6A7B8E",
              fontSize: "x-large",
              width: "30px",
              minHeight: "30px",
              padding: "3px",
            }}
          />
        </Tooltip> */}

        <i
          className="fa-regular fa-trash-can"
          aria-hidden="true"
          style={{
            borderRadius: "25%",
            color: "#6A7B8E",
            fontSize: "18px",
            width: "30px",
            minHeight: "30px",
            padding: "3px",
            alignContent: "center",
            textAlign: "center",
            fontWeight: "600",
          }}
          onClick={this.onClick.bind(this)}
        ></i>
      </span>
    );
  }
}
export default DeleteButton;
